import { useEffect, useRef, useContext } from "react";

import { GlobalContext } from "../../contexts/globalContext"

import io from "socket.io-client";
import { Device } from 'mediasoup-client'

function MediasoupInitializer({ setInitializeMediasoup }) {

    const { ioSettings } = useContext(GlobalContext)

    const socketRoomRef = useRef();

    let params = {
        encodings: [
            {
                rid: 'r0',
                maxBitrate: 100000,
                scalabilityMode: 'S1T3',
            },
            {
                rid: 'r1',
                maxBitrate: 300000,
                scalabilityMode: 'S1T3',
            },
            {
                rid: 'r2',
                maxBitrate: 900000,
                scalabilityMode: 'S1T3',
            },
        ],
        // https://mediasoup.org/documentation/v3/mediasoup-client/api/#ProducerCodecOptions
        codecOptions: {
            videoGoogleStartBitrate: 1000
        }
    }

    const videoParamsRef = useRef();
    const audioParamsRef = useRef();
    let consumingTransports = [];

    let device;
    let rtpCapabilities;
    let producerTransport;
    let consumerTransports = [];
    let audioProducer;
    let videoProducer;

    useEffect(() => {
        socketRoomRef.current = io.connect(process.env.REACT_APP_MEDIASOUP_URL, { secure: true, reconnect: true, rejectUnauthorized: false })
        socketRoomRef.current.pingTimeout = 1000;
        socketRoomRef.current.pingInterval = 3000;

        socketRoomRef.current.on('connection-success', () => {
            GetLocalStream();
        })

        socketRoomRef.current.on('new-producer', ({ producerId }) => signalNewConsumerTransport(producerId))

        socketRoomRef.current.on('producer-closed', ({ remoteProducerId }) => {
            // server notification is received when a producer is closed
            // we need to close the client-side consumer and associated transport
            const producerToClose = consumerTransports.find(transportData => transportData.producerId === remoteProducerId)
            if (producerToClose) {
                producerToClose.consumerTransport.close()
                producerToClose.consumer.close()
            }

            // remove the consumer transport from the list
            consumerTransports = consumerTransports.filter(transportData => transportData.producerId !== remoteProducerId)

        })

        socketRoomRef.current.on("disconnect", () => {

            device = null;
            rtpCapabilities = null;

            producerTransport?.close();
            producerTransport = null;

            for (let index = 0; index < consumerTransports.length; index++) {
                const element = consumerTransports[index];
                element.consumerTransport.close();
            }

            audioParamsRef.current = {};
            videoParamsRef.current = { params };

            consumerTransports = [];
            consumingTransports = [];
            audioProducer?.close();
            videoProducer?.close();
            audioProducer = null;
            videoProducer = null;

        });

        audioParamsRef.current = {};
        videoParamsRef.current = { params };

       // creez();

        return () => {
            socketRoomRef.current.close();
        }
    }, [])


    const GetLocalStream = () => {
        navigator.mediaDevices.getUserMedia({
            audio: false,
            video: {
                facingMode: "user",
                width: {
                    min: 640,
                    max: 960,
                },
                height: {
                    min: 400,
                    max: 540,
                }
            }
        })
            .then(StreamSuccess)
            .catch(error => {
                console.log({ type: "ERROR", message: "Error joining media server: " + error.message, forever: true });
            })

    }

    const StreamSuccess = (stream) => {
        videoParamsRef.current = { track: stream.getVideoTracks()[0], ...videoParamsRef.current };

        JoinRoom();
    }

    const JoinRoom = () => {
        socketRoomRef.current.emit('joinRoom', { roomName: "initializeRoom", clientId: "9u92ue92u" }, (data) => {
            rtpCapabilities = data.rtpCapabilities

            CreateDevice()
        })
    }

    const CreateDevice = async () => {
        try {
            //device = new Device()
            device = await Device.factory({ handlerName: "Chrome111" });

            // https://mediasoup.org/documentation/v3/mediasoup-client/api/#device-load
            // Loads the device with RTP capabilities of the Router (server side)
            await device.load({
                // see getRtpCapabilities() below
                routerRtpCapabilities: rtpCapabilities
            })

            // once the device loads, create transport
            CreateSendTransport()

        } catch (error) {
            console.log("CreateDevice", error);
        }
    }

    const CreateSendTransport = () => {
        // see server's socket.on('createWebRtcTransport', sender?, ...)
        // this is a call from Producer, so sender = true
        socketRoomRef.current.emit('createWebRtcTransport', { consumer: false }, ({ params }) => {
            // The server sends back params needed 
            // to create Send Transport on the client side
            if (params.error) {
                return
            }

            // creates a new WebRTC Transport to send media
            // based on the server's producer transport params
            // https://mediasoup.org/documentation/v3/mediasoup-client/api/#TransportOptions
            producerTransport = device.createSendTransport(params)

            // https://mediasoup.org/documentation/v3/communication-between-client-and-server/#producing-media
            // this event is raised when a first call to transport.produce() is made
            // see connectSendTransport() below
            producerTransport.on('connect', async ({ dtlsParameters }, callback, errback) => {
                try {
                    // Signal local DTLS parameters to the server side transport
                    // see server's socket.on('transport-connect', ...)
                    await socketRoomRef.current.emit('transport-connect', {
                        dtlsParameters,
                    })

                    // Tell the transport that parameters were transmitted.
                    callback()

                } catch (error) {
                    errback(error)
                }
            })

            producerTransport.on('produce', async (parameters, callback, errback) => {


                try {

                    // await socketRoomRef.current.emit('transport-produce', {
                    //     kind: parameters.kind,
                    //     rtpParameters: parameters.rtpParameters,
                    //     participant: currentParticipant,
                    // }, ({ id, producersExist }) => {
                    //     callback({ id })


                    //     if (producersExist) getProducers()
                    // })

                    await socketRoomRef.current.emit('transport-produce', {
                        kind: parameters.kind,
                        rtpParameters: parameters.rtpParameters,
                        participant: {},
                    }, ({ id, producersExist }) => {
                        callback({ id });

                        // ⚠️ Adaugă un delay de siguranță înainte de getProducers
                        setTimeout(() => {
                            socketRoomRef.current.close();
                            setInitializeMediasoup(false);
                        }, 1000);
                    });
                } catch (error) {
                    errback(error)
                }
            })

            connectSendTransport()
        })
    }

    const connectSendTransport = async () => {
        // we now call produce() to instruct the producer transport
        // to send media to the Router
        // https://mediasoup.org/documentation/v3/mediasoup-client/api/#transport-produce
        // this action will trigger the 'connect' and 'produce' events above

        if (ioSettings && ioSettings.audio) {
            audioProducer = await producerTransport.produce(audioParamsRef.current);
            audioProducer.on('trackended', () => {
            })

            audioProducer.on('transportclose', () => {
            })
        }

        if (!ioSettings || ioSettings.video) {
            videoProducer = await producerTransport.produce(videoParamsRef.current);

            videoProducer.on('trackended', () => {
            })

            videoProducer.on('transportclose', () => {
            })
        }
    }

    const signalNewConsumerTransport = async (remoteProducerId) => {
        //check if we are already consuming the remoteProducerId
        if (consumingTransports.includes(remoteProducerId)) return;
        consumingTransports.push(remoteProducerId);

        await socketRoomRef.current.emit('createWebRtcTransport', { consumer: true }, ({ params }) => {
            // The server sends back params needed 
            // to create Send Transport on the client side
            if (params.error) {
                return
            }

            let consumerTransport
            try {
                consumerTransport = device.createRecvTransport(params)
            } catch (error) {
                return
            }

            consumerTransport.on('connect', async ({ dtlsParameters }, callback, errback) => {
                try {
                    // Signal local DTLS parameters to the server side transport
                    // see server's socket.on('transport-recv-connect', ...)
                    await socketRoomRef.current.emit('transport-recv-connect', {
                        dtlsParameters,
                        serverConsumerTransportId: params.id,
                    })

                    // Tell the transport that parameters were transmitted.
                    callback()
                } catch (error) {
                    // Tell the transport that something was wrong
                    errback(error)
                }
            })

            connectRecvTransport(consumerTransport, remoteProducerId, params.id)
        })
    }

    // server informs the client of a new producer just joined


    const getProducers = () => {
        socketRoomRef.current.emit('getProducers', producerIds => {
            // for each of the producer create a consumer
            producerIds.forEach(signalNewConsumerTransport)
        })
    }

    const connectRecvTransport = async (consumerTransport, remoteProducerId, serverConsumerTransportId) => {
        // for consumer, we need to tell the server first
        // to create a consumer based on the rtpCapabilities and consume
        // if the router can consume, it will send back a set of params as below
        await socketRoomRef.current.emit('consume', {
            rtpCapabilities: device.rtpCapabilities,
            remoteProducerId,
            serverConsumerTransportId,
        }, async ({ params }) => {
            if (params.error) {
                return
            }

            // then consume with the local consumer transport
            // which creates a consumer
            const consumer = await consumerTransport.consume({
                id: params.id,
                producerId: params.producerId,
                kind: params.kind,
                rtpParameters: params.rtpParameters
            })

            consumerTransports = [
                ...consumerTransports,
                {
                    consumerTransport,
                    serverConsumerTransportId: params.id,
                    producerId: remoteProducerId,
                    consumer,
                },
            ]

            // create a new div element for the new consumer media

            socketRoomRef.current.emit('consumer-resume', { serverConsumerId: params.serverConsumerId })
        })
    }


    return (
        <></>
    );
}

export default MediasoupInitializer;
